<template>
    <rkm-form
        ref="Form"
        show-legend
    >
        <rkm-row>
            <rkm-col
                cols="2"
                v-if="model.imagem.valorSigtap == false || model.exigeProcedimento == false"
            >
                <rkm-form-input
                    label="Valor do exame"
                    ref="valorExame"
                    v-model="model.imagem.valor"
                    v-money="money"
                    prepend="R$"
                    :validations="validations.valor"
                    key="valorExame"
                />
            </rkm-col>

            <rkm-col
                cols="2"
                v-if="model.imagem.valorSigtap == true && model.procedimento && model.exigeProcedimento == true"
            >
                <rkm-form-input
                    label="Valor sigtap"
                    ref="valorSigtap"
                    v-model="model.procedimento.valorServicoAmbilatorial"
                    disabled
                    v-money="money"
                    prepend="R$"
                    key="valorSigtap"
                />
            </rkm-col>

            <rkm-col cols="auto" v-if="model.exigeProcedimento == true">
                <rkm-form-checkbox
                    inline
                    :label="false"
                    v-model="model.imagem.valorSigtap"
                    @change="selecionarSigtap"
                >
                    Valor do sigtap
                </rkm-form-checkbox>
            </rkm-col>

            <rkm-col cols="2">
                <rkm-form-input
                    label="Validade do exame"
                    number
                    v-model="model.imagem.validade"
                />
            </rkm-col>

            <rkm-col cols="auto">
                <rkm-form-checkbox
                    v-model="model.imagem.outroMunicipio"
                    inline
                    :label="false"
                >
                    Outro município
                </rkm-form-checkbox>
            </rkm-col>

            <rkm-col cols="auto">
                <rkm-form-checkbox
                    v-model="model.imagem.provisorio"
                    inline
                    :label="false"
                >
                    Provisório
                </rkm-form-checkbox>
            </rkm-col>

            <rkm-col cols="auto">
                <rkm-form-checkbox
                    v-model="model.imagem.exigirPesoAlturaCircunferencia"
                    inline
                    :label="false"
                >
                    Exigir peso, altura e circunferência abdominal para solicitação de exame
                </rkm-form-checkbox>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <rkm-text-editor
                    label="Resultado"
                    v-model="model.imagem.resultado"
                    :validations="validations.resultado"
                    name="resultado"
                    row="4"
                    max-rows="4"
                    v-on:ready="quill => editorQuill = quill"
                />
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>

// Mixins.
import { object, mask} from '@/mixins'

//Directives
import { VMoney } from 'v-money'

export default {
    computed:{
        validations() {
            return {
                valor: {max: 12},
                resultado: {
                    max_without_html: 4000,
                    min: 3,
                },
            }
        },
    },
    props: {
        form: { type: Object, required: true },
        model: { type: Object, required: true },
    },
    data:() => ({
        selecionados: false,
        money: {
          decimal: ',',
          thousands: '.',
          suffix: '',
          precision: 2,
          masked: false,
          editorQuill:null,
        },
    }),
    methods: {
        validate() {
            return this.$refs.Form.validate()
        },
        selecionarSigtap(){

            if(this.selecionados == true){

                this.selecionados = false
            } else {

                this.selecionados = true
            }
        }
    },
    directives: { money: VMoney },
    mixins: [object, mask ],
    watch: {
        'model.imagem.resultado'() {

            const max = this.validations.resultado?.max_without_html

            if (this.editorQuill && max && this.editorQuill.getLength() > max + 1) {
                this.editorQuill.deleteText(max, this.editorQuill.getLength())
            }
        },
    }
}
</script>